export const profileSelector = (state: any) => {
    const profiles = state.auth.profiles
    return (
        profiles?.find((profile: {selectedProfile: any}) => profile?.selectedProfile) ||
        profiles?.find((profile: {isDefaultProfile: any}) => profile?.isDefaultProfile) ||
        profiles?.find((profile: {profileType: string}) => profile?.profileType === 'SUPER_PROFILE') ||
        profiles?.[0]
    )
}
